import anime from "animejs";

export const scaleUp = (target, scale, duration) => ({
  targets: target,
  opacity: [0, 1],
  scale: scale,
  duration: duration,
  easing: "easeInOutSine"
});

export const fadeIn = (targets, duration, begin, itemDelay, startDelay) => ({
  begin: begin,
  targets: targets,
  opacity: [0, 1],
  duration: duration ? duration : 1000,
  easing: "easeInOutSine",
  delay: itemDelay
    ? startDelay
      ? (target, index) => index * itemDelay + startDelay
      : (target, index) => index * itemDelay
    : startDelay
      ? startDelay
      : 0
});

export const fadeOut = (target, startDelay) => ({
  targets: target,
  opacity: [1, 0],
  duration: 500,
  delay: startDelay ? startDelay : 0
});

export const fadeOutList = (targets, startDelay, itemDelay) => ({
  targets: targets,
  opacity: [1, 0],
  duration: 100,
  easing: "easeInOutSine",
  delay: (target, index) => itemDelay * index + startDelay
});

export const lineDrawing = target => ({
  targets: target,
  strokeDashoffset: [anime.setDashoffset, 0],
  duration: 1000,
  easing: "easeInOutSine"
});

export const lineRemove = target => ({
  targets: target,
  strokeDashoffset: [0, anime.setDashoffset],
  duration: 1000,
  easing: "easeInOutSine"
});

export const fadeInFromLeftAndRight = (targets, startDelay, itemDelay) => ({
  targets: targets,
  translateX: (el, i) => (i % 2 === 0 ? [-1000, 0] : [1000, 0]),
  opacity: [0, 1],
  delay: (target, index) => index * itemDelay + startDelay,
  duration: 1500,
  easing: "easeOutElastic",
  elasticity: 100
});

export const fadeInFromRight = targets => ({
  targets: targets,
  translateX: (el, i) => [1000, 0],
  opacity: [0, 1],
  delay: (target, index) => index * 1000,
  duration: 1500,
  easing: "easeOutElastic",
  elasticity: 100
});

export const fromRight = targets => ({
  targets: targets,
  translateX: [1000, 0],
  duration: 1500,
  easing: "easeOutElastic",
  elasticity: 100
});

export const fromUp = targets => ({
  targets: targets,
  translateY: [-1000, 0],
  duration: 1500,
  easing: "easeOutElastic",
  elasticity: 100
});

export const typing = (targets, d, duration) => ({
  targets: targets,
  d: d,
  duration: duration,
  easing: "easeInOutSine"
});

export const translateY = (targets, translate) => ({
  targets: targets,
  translateY: translate,
  duration: 500,
  elasticity: 0,
  easing: "linear"
});



// WEBPACK FOOTER //
// ./src/utils/animations.js